import type {
  MemoryCreationMethod,
  MemoryRecordResponse,
  MemoryStatus,
} from '@terra/shared-contracts-memory';

export type EndpointMemoryCreationMethod = MemoryCreationMethod;

export type EndpointMemoryRow = MemoryRecordResponse;

export const canRemoveEndpointMemory = ({
  creationMethod,
  status,
}: {
  creationMethod?: EndpointMemoryCreationMethod;
  status?: MemoryStatus;
}): boolean => {
  if (creationMethod === 'system') {
    return status === 'rejected';
  }

  return true;
};

export const endpointMemoryStatusTooltipKey = ({
  status,
  creationMethod,
}: {
  status: MemoryStatus;
  creationMethod?: EndpointMemoryCreationMethod;
}): `statusTooltip.${string}` => {
  if (status === 'rejected' && creationMethod === 'system') {
    return 'statusTooltip.rejectedSystem';
  }

  return `statusTooltip.${status}`;
};

export const canEditEndpointMemory = ({
  creationMethod,
}: {
  creationMethod?: EndpointMemoryCreationMethod;
}): boolean => creationMethod !== 'system';

export const toMemoryRecordResponse = (
  memory: EndpointMemoryRow,
): MemoryRecordResponse => memory;
